import { createNotification } from '@laigu/utils';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal } from 'antd';

const networkNotification = () => {
  createNotification({
    title: '网络断开，你可能会遗漏新消息',
    body: `不必担心，刷新工作台即可重新连接`,
    onclick: () => {
      if (window.location.pathname.startsWith('/chat')) {
        window.location.reload();
      } else {
        const modal = Modal.confirm({
          title: '是否重新加载来鼓',
          content: '确认后，你在当前页面的操作记录可能会丢失',
          okText: '确认',
          cancelText: '取消',
          icon: <ExclamationCircleOutlined />,
          width: 356,
          onCancel: () => {
            modal.destroy();
          },
          onOk: () => {
            window.location.reload();
            modal.destroy();
          }
        });
      }
    }
  });
};

export default networkNotification;
